import { createEvent } from 'effector'

export const innerWidthChangeEvent = createEvent<number>()
export const changeBuyKeysModalVisible = createEvent<boolean>()
export const delayedPathUpdate = createEvent()
export const changeShopTab = createEvent<number>()
export const changeSocialTab = createEvent<number>()
